import { render, staticRenderFns } from "./FancyBoxComponent.vue?vue&type=template&id=5893d0e7"
import script from "./FancyBoxComponent.vue?vue&type=script&lang=js"
export * from "./FancyBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./FancyBoxComponent.vue?vue&type=style&index=0&id=5893d0e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports